import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  StaffBenefitCategoryResponse,
  StaffBenefitRequest,
  StaffBenefitResponse,
  StaffBenefitType,
} from "../model/benefit.model";
import { BASE_PATH } from "../variables";

@Injectable({ providedIn: "root" })
export class StaffBenefitsService {
  private readonly apiUrl: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.apiUrl = `${basePath.replace(/\/$/, "")}/api/v1/benefits`;
  }

  list(filters?: {
    companyId?: number;
    type?: StaffBenefitType;
    active?: boolean;
  }): Observable<StaffBenefitResponse[]> {
    let params = new HttpParams();

    if (filters?.companyId != null) {
      params = params.set("companyId", filters.companyId);
    }

    if (filters?.type) {
      params = params.set("type", filters.type);
    }

    if (filters?.active != null) {
      params = params.set("active", filters.active);
    }

    return this.http.get<StaffBenefitResponse[]>(this.apiUrl, { params });
  }

  getById(benefitId: number): Observable<StaffBenefitResponse> {
    return this.http.get<StaffBenefitResponse>(`${this.apiUrl}/${benefitId}`);
  }

  create(request: StaffBenefitRequest): Observable<StaffBenefitResponse> {
    return this.http.post<StaffBenefitResponse>(`${this.apiUrl}`, request);
  }

  update(
    benefitId: number,
    request: StaffBenefitRequest,
  ): Observable<StaffBenefitResponse> {
    return this.http.put<StaffBenefitResponse>(
      `${this.apiUrl}/${benefitId}`,
      request,
    );
  }

  deactivate(benefitId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${benefitId}`);
  }

  listCategories(active = true): Observable<StaffBenefitCategoryResponse[]> {
    const url = this.apiUrl.replace(/\/benefits$/, "/benefit-categories");
    return this.http.get<StaffBenefitCategoryResponse[]>(url, {
      params: new HttpParams().set("active", active),
    });
  }
}
